export const defaultDocumentTypes = [{ value: 'other', label: 'Other' }]

export const invoiceFileTypes = [
  { value: 'supporting-quote', label: 'Supporting Quote' },
  { value: 'supporting-invoice', label: 'Supporting Invoice' },
]

export const propertyFileTypes = [
  { value: 'property-report', label: 'Property Report' },
  { value: 'mandate', label: 'Mandate' },
  { value: 'other', label: 'Other' },
]

export const leaseFileTypes = [
  { value: 'lease-agreement', label: 'Lease Agreement' },
  { value: 'renewal-addendum', label: 'Renewal Addendum' },
  { value: 'mandatory-disclosure-form', label: 'Mandatory Disclosure Form' },
  { value: 'other', label: 'Other' },
]

export const naturalPersonDocumentTypes = [
  { value: 'identification', label: 'Identification' },
  { value: 'proof-of-sars-tax-number', label: 'Proof of SARS Tax Number' },
  { value: 'credit-check', label: 'Credit Check' },
  { value: 'bank-confirmation-letter', label: 'Bank Confirmation Letter' },
  { value: 'proof-of-address', label: 'Proof of Address' },
  { value: 'bank-statement', label: 'Bank Statement' },
  { value: 'payslip', label: 'Payslip' },
  { value: 'other', label: 'Other' },
]

export const entityDocumentTypes = [
  { value: 'registration-document', label: 'Registration Document' },
  { value: 'proof-of-sars-vat-number', label: 'Proof of SARS VAT Number' },
  { value: 'bank-confirmation-letter', label: 'Bank Confirmation Letter' },
  { value: 'proof-of-address', label: 'Proof of Address' },
  { value: 'bank-statement', label: 'Bank Statement' },
  { value: 'other', label: 'Other' },
]
